import { useState } from 'react';

const useBrochure = () => {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', phone: '' });

  const downloadBrochure = () => setShowModal(true);
  const closeModal = () => {
    setShowModal(false);
    setFormData({ name: '', email: '', phone: '' });
  };

  const updateField = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    if (!formData.name || !formData.email || !formData.phone) return;

    // Send email notification
    const formElement = document.createElement('form');
    formElement.action = 'https://formsubmit.co/contact@enessafoods.com';
    formElement.method = 'POST';
    formElement.style.display = 'none';

    const fields = [
      { name: '_subject', value: 'Brochure Download Request - Enessa Foods' },
      { name: 'Name', value: formData.name },
      { name: 'Email', value: formData.email },
      { name: 'Phone', value: formData.phone },
      { name: '_captcha', value: 'false' },
      { name: '_template', value: 'table' },
      { name: '_next', value: window.location.href },
    ];

    fields.forEach(field => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = field.name;
      input.value = field.value;
      formElement.appendChild(input);
    });

    document.body.appendChild(formElement);
    formElement.submit();
    document.body.removeChild(formElement);

    // Download PDF
    const link = document.createElement('a');
    link.href = '/brochure/Brochure.pdf';
    link.download = 'Enessa-Foods-Brochure.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    closeModal();
  };

  return {
    showModal,
    formData,
    updateField,
    downloadBrochure,
    closeModal,
    handleSubmit,
  };
};

export default useBrochure;